export default __webpack_public_path__ + "static/media/gdi_ico_employees.38195ee4.svg";